import { useDispatch } from 'react-redux';

import { useConsents } from '../../Consents/hooks';
import { actions as acceptConsentActions } from '../../../redux/programs/acceptConsent';

export function useProgramConsents({
  program,
  consents,
  todo = {},
  formatMessage,
}) {
  const dispatch = useDispatch();

  const onAccept = consent =>
    dispatch(
      acceptConsentActions.init({
        todoId: todo.itemId,
        consentId: consent.id,
        programId: program.id,
      }),
    );

  const details = {
    title: formatMessage({ id: 'program.consent.title' }),
    subtitle: formatMessage({ id: 'program.consent.subtitle' }),
    for: formatMessage(
      { id: 'program.consent.for' },
      { name: program.organizationName },
    ),
  };

  return useConsents({ details, consents, onAccept });
}



// WEBPACK FOOTER //
// ./src/components/Programs/hooks/useProgramConsents.js